import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Checkbox, DatePicker, Input} from 'antd';
import BaseComponent from '../../../base/BaseComponent';
import moment from "moment";

const {RangePicker} = DatePicker;
const {Search} = Input;

export default class SelectPublic extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            query: {
                queryName: '', //查询字段
                Subdirectory: false,
                startTimeLong: '',
                endTimeLong: '',
                startTime: '',
                endTime: '',
                IsRefresh: true,//是否刷新数据
                isShowStop:false
            },
            disabled:false,
            pickerDisabled: false

        }
    }

    componentWillMount() {
    }

    componentDidMount() {
    }

    onOpenChange = (val) => {
        this.setState({pickerDisabled: val})
    };

    render() {
        return (
            <div style={{width: '520px', textAlign: "right", position: 'relative'}} >
                {this.state.query.Subdirectory ? null :
                    <RangePicker
                        className={'resourceSearch'}
                        value={[this.state.query.startTime ? moment(this.state.query.startTime) : undefined,
                            this.state.query.endTime ? moment( this.state.query.endTime ) : undefined]}
                        allowClear
                        style={{width: 250, textAlign: "center"}}
                        onChange={this.onChange}
                        onOpenChange={
                            this.onOpenChange
                        }
                    />}
                {this.state.pickerDisabled &&
                <div style={{width: 543, height: 23, position: 'absolute', top: 4, left: 11, zIndex: 10000}}></div>}
                <Search
                    allowClear
                    className={'resourceSearch'}
                    placeholder="请输入关键字"
                    value={this.state.query.queryName}
                    disabled={this.state.disabled}
                    onSearch={(value) => {
                        this.state.query.queryName = value;
                        this.state.query.IsRefresh = true;
                        this.setState({}, () => {
                            this.props.callBack && this.props.callBack(this.state.query)
                        })

                    }}
                    style={{width: 150, marginLeft: 5}}
                    onChange={(e) => {
                        this.state.query.queryName = e.target.value;
                        this.setState({})
                    }}
                />
                <Checkbox style={{marginLeft: 10}}  checked={this.state.query.Subdirectory} onChange={(e => {
                    this.state.query.Subdirectory = e.target.checked;
                    this.setState({}, () => {
                        this.Selected()
                    })
                })}></Checkbox>
                <span style={{paddingLeft:'5px'}}>包含子目录</span>
                <style>{`.resourceSearch .ant-input{background:#f5f8fc}`}</style>
            </div>


        )
    }

    //包含子目录得方法
    Selected = () => {
        //选中包含子目录 将时间置空
        if (this.state.query.Subdirectory) {
            this.state.query.startTimeLong = '';
            this.state.query.endTimeLong = '';
            if (this.state.query.startTime === '') {
                this.state.query.IsRefresh = false;
            } else {
                this.state.query.endTime = '';
                this.state.query.startTime = '';
                this.state.query.IsRefresh = false;
            }
        } else {
            this.state.query.IsRefresh = true
        }
        this.props.callBack && this.props.callBack(this.state.query)
    };


    //时间选择器
    onChange = (moment, dateString) => {
        if (moment.length) {
            let startTimeLong = moment[0]._d.setHours(0, 0, 0, 0);
            let endTimeLong = moment[1]._d.setHours(23, 59, 59);
            this.state.query.startTime = moment[0];
            this.state.query.endTime =moment[1];
            this.state.query.startTimeLong = startTimeLong;
            this.state.query.endTimeLong = endTimeLong;
            this.state.query.IsRefresh = true;
            this.setState({}, () => {
                this.props.callBack && this.props.callBack(this.state.query)
            });
        } else {
            this.state.query.startTime = '';
            this.state.query.endTime = '';
            this.state.query.startTimeLong = '';
            this.state.query.endTimeLong = '';
            this.state.query.IsRefresh = true;
            this.setState({}, () => {
                this.props.callBack && this.props.callBack(this.state.query)
            });
        }
    };
   //重置
    init = () => {
        this.setState({query: {}})
    };
    isDisabled=(data)=>{
        this.setState({disabled:data})
    }
}

